import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../../contexts/AuthContext";
import { toast } from "react-toastify";
import styles from "./ProReels.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";

const ProReels = () => {
  const { accessToken } = useAuth();
  const [reels, setReels] = useState([]);
  const [sortOrder, setSortOrder] = useState("latest");

  // Helper function to get Instagram embed URL
  const getEmbedUrl = (url) => {
    if (url) {
      return `https://www.instagram.com/p/${url
        .split("/")
        .slice(-2, -1)}/embed/`;
    }
    return null;
  };

  // Fetch Reels on component mount
  useEffect(() => {
    const fetchReels = async () => {
      if (!accessToken) return;

      try {
        const response = await axios.get(
          `${import.meta.env.VITE_BACKEND_URL}/dash/pro-sm/list?typeSMId=2`,
          {
            headers: {
              Authorization: accessToken,
            },
          }
        );

        if (response.status === 200 && response.data.success) {
          setReels(response.data.smLinks);
        } else {
          toast.error(response.data.message || "Failed to fetch reels.");
        }
      } catch (error) {
        console.error("Error fetching reels:", error);
        toast.error("Error fetching reels.");
      }
    };

    fetchReels();
  }, [accessToken]);

  // Sort reels by `created_at` based on selected order
  const sortedReels = reels.sort((a, b) => {
    if (sortOrder === "latest") {
      return new Date(b.created_at) - new Date(a.created_at);
    }
    return new Date(a.created_at) - new Date(b.created_at);
  });

  return (
    <>
      <Navbar />
      <div className={styles.container}>
        <h2 className={styles.title}>All Reels</h2>
        <div className={styles.filterContainer}>
          <label htmlFor="sortOrder">Sort by:</label>
          <select
            id="sortOrder"
            value={sortOrder}
            onChange={(e) => setSortOrder(e.target.value)}
            className={styles.select}
          >
            <option value="latest">Latest</option>
            <option value="oldest">Oldest</option>
          </select>
        </div>
        <div className={styles.reelsGrid}>
          {sortedReels.map((reel, index) => (
            <div key={index} className={styles.reelBox}>
              <iframe
                className={styles.video}
                src={getEmbedUrl(reel.url)}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
              <div className={styles.reelInfo}>
                <p className={styles.reelUrl}>
                  <a href={reel.url} target="_blank" rel="noopener noreferrer">
                    View on Instagram
                  </a>
                </p>
                <p className={styles.reelDate}>
                  Created at: {new Date(reel.created_at).toLocaleDateString()}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ProReels;
